import * as Yup from 'yup';
import { DictionaryDecisionType } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryDecisionType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
